export const Paths = {
  PRIVATE: {
    HOME: "/",
    DEPOSIT: "/deposit",
    PROFILE: "/profile",
    CONTACT: "/contact",
    DAILY_REWARD: "/daily-reward",
    CASHBACK: "/cashback",
    TRANSACTION: "/transaction",
    BANK_ACCOUNTS: "/bank-accounts",
    BET_HISTORY: "/betting-history",
    LANGUAGE: "/language",
    UPDATE_BANK_FORCE: "/onboard/bank",
    UPDATE_PIN_FORCE: "/reset-pin",
    UPDATE_BANK: "/update-bank",
    CHANGE_PASSWORD: "/change-password",
    TERMS_CONDITIONS: "/terms-and-conditions",
    DEPOSIT_CALLBACK: "/:provider/:orderRef/return",
    REFERRAL: "/referral",
    PRIZES: "/prizes",
    REFER_BALLS: "/refer-balls",
    PERSONAL_INFO: "/personal-info",
  },
  PUBLIC: {
    ONBOARD: "/onboard",
    ONBOARD_LOGIN: "/onboard/login",
    ONBOARD_REGISTER: "/onboard/register",
    LOGIN: "/login",
    LOGIN_PIN: "/login/pin",
    REGISTER: "/register",
    REGISTER_OTP: "/register/otp",
    FORGOT_PIN: "/forgot-pin",
    MAINTENANCE: "/maintenance",
    REFERRAL_CALLBACK: "/r/:refCode",
  },
};
